<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 20/12/2021
  -->

<!--
IMPORTANT!!! SEO-CRITICAL PATH.
IN CASE OF ANY CHANGES, MAKE SURE
TO CHECK PAGE SCORE ON https://pagespeed.web.dev/
-->
<template>
	<div class="h-100 relative">
<!--		<MobileStopperScreen v-if="isMobileScreen"/>-->
		<div v-if="hasTeacher" class="mb-3 h3 text-center mt-2">
			<div>Student access by {{teacherName}}</div>
		</div>

		<div class="h-100 relative">
			<GenogramMain
				ref="genogramMain"
				class="h-100"
				:hide-save-button="false"
				:show-watermark="true"
				:client-profile="clientProfile"
				:dataManagerProp="localDataManager"
				:actionListener="actionListener"
				@templateAdded="onTemplateAdded"
				@detailsVisibilityChanged="onDetailsVisibilityChanged"
			/>

			<div class="absolute"
				 :style="{'right': '10px', 'top': savePanelTopComputed}">
				<qw-button
					v-if="isLoggedIn"
					class="px-5"
					@click="goToDashboard">
					My Genograms
				</qw-button>

<!--				font-size-4 is needed for SEO. Otherwise it complains about accessibility issue becuase of low contrast between words and background-->
				<qw-button
					type="primary"
					class="px-5 font-size-4"
					@click="onSaveClicked">
					{{ saveButtonTextComputed }}
				</qw-button>
			</div>

			<div class="fixed"
				 style="left: 10px; bottom: 50px; z-index: 9;">

				<qw-button
					v-if="canShowTutorial"
					type="primary"
					style="width: 185px"
					class="px-5 font-size-4"
					@click="showVideoDialogClicked">
					{{showTutorialTitleComputed}}
				</qw-button>
			</div>
		</div>
		<GatherFeedbackView
			style="z-index: 50"
			@feedbackClicked="onFeedbackClicked"
		/>

		<div v-if="aiDevTest && isDevEnvFn()"
			 class="bottom-right-fixed"
			 style="z-index: 9999999;width: 500px;">
			<div class="card p-3">
				<FormTextRow
					:multiline="true"
					placeholder="Input test JSON command here"
					:min-rows="4"
					v-model="aiTestInput"
				/>
				<qw-button
					type="primary"
					@click="onRunCommandClicked">
					Run command
				</qw-button>
			</div>

		</div>

		<LoadingIndicator/>




		<span v-if="isLoadingGlobal">
			<div id="loading" style="background: rgba(255, 255, 255, 0.8)">
				<div class="spinner">
					<div class="bounce1"></div>
					<div class="bounce2"></div>
					<div class="bounce3"></div>
					<span class="text text-center">
						<div style="padding: 5px; background: white">Loading... Just a moment...</div>

					</span>
				</div>

			</div>
		</span>
	</div>

</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import GenogramMain from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramMain.vue";
import ClientProfile from "@shared/Profile/ClientProfile";

import LocalDataManager from "@/core/js/backend/LocalDataManager";
import {createDialogLazy} from "@/utils/helpers-external";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
let VideoDialog = () => import("@/core/components/Dialogs/QwoachDialog/VideoDialog.vue");
import MobileStopperScreen from "@/tools/MobileStopperScreen.vue";

let videoDialog = createDialogLazy(VideoDialog)
import {GenogramToolId} from "@shared/Profile/CoachingToolsConstants.js";
import {fromBase64, isDevEnv, isObject, JsonParseSecure, logError} from "@/utils/helpers";
import {SettingNameEnum} from "@shared/enums/SettingNameEnum";
import {isMobileScreen} from "@/core/screenHelper";
import {SettingsCookie} from "@/core/js/Cookie/SettingsCookie";
import GatherFeedbackView from "@/tools/FeedbackGather/GatherFeedbackView.vue";
import {messageDialog} from "@/core/components/Dialogs/dialog";
import teacherMapObj from "@/core/modules/Login/TeacherMap";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import GenogramLayoutManager from "@/tools/GenogramTool/GenogramLayoutManager";

let CreateCoachAccountDialog = () => import("@/core/modules/Login/CreateCoachAccountDialog.vue");
let CreateAccountGenogramDialog = () => import("@/tools/CreateAccountFreeToolsDialog.vue");
let GenogramSurveyDialog = () => import("@/tools/GenogramTool/GenogramSurveyDialog.vue");

let createAccountGenogramDialog = createDialogLazy(CreateCoachAccountDialog)
let getClientNameDialog = createDialogLazy(CreateAccountGenogramDialog)
let genogramSurveyDialog = createDialogLazy(GenogramSurveyDialog)


export default {
	name: "GenogramToolMain",
	components: {FormTextRow, GatherFeedbackView, MobileStopperScreen, LoadingIndicator, GenogramMain},
	extends: BaseComponent,

	props: {
		specialId: String,
		settingsParam: {Object, default: () => ({})},
		utm_params: {Object, default: () => {}},
		teacherId: String,
		aiDevTest: Boolean, //show json command input to test AI integration
	},

	data() {
		return {
			isLoadingGlobal: false,
			cookieSettings: new SettingsCookie(),
			clientProfile: new ClientProfile(),
			localDataManager: new LocalDataManager(),
			isDirty: true,
			canShowTutorial: true,
			noTrialPlanMonthly: "895944",
			noTrialPlanYearly: "897164",
			settings: {},
			loadFullAppPromise: null,
			aiTestInput: "",
		}
	},

	created() {


		this.$analyticManager.trackAppEntry({first_contact: 'genogram_tools'})
		this.cookie.setOnce('qw_ft', "genogram_tools");
		this.saveSettingsFromUrl()
		this.restoreSettings()
		this.setupUtmParams()
		this.setupCampaignData()

		this.$analyticManager.trackEvent("Genogram tools opened")

		window.addEventListener('beforeunload', this.beforeWindowUnload)
		window.addEventListener('onbeforeunload', this.beforeWindowUnload)

		this.cookie.setOnce('qw_ft', "genogram_tools");
		// if(isDevEnv){
		// 	this.dataManager.apiPostTestAmplitudeEventPropsMerge({
		// 		amplitudeDeviceId: this.$analyticManager.getAmplitudeDeviceId()
		// 	})
		// }

		// we don't load it like this because it lags the user interaction which badly impacts SEO (the INP metric)
		// setTimeout(() => {
		// 	this.loadFullApp()
		// }, 8000)

		if(isMobileScreen()){
			setTimeout(() => {
				let instructions = document.querySelector("#genogramInstructions")
				console.log("GenogramToolMain.created: instructions = ", instructions)
				if(instructions){
					instructions.innerHTML += "<br/><br/>Tip: switch to landscape or open on desktop for better experience."
				}
			}, 8000)
		}


	},

	mounted() {
		if(!isMobileScreen()){
			// this.showVideoDialog()
		}
	},

	beforeUnmount () {
		window.removeEventListener('beforeunload', this.beforeWindowUnload)
		window.removeEventListener('onbeforeunload', this.beforeWindowUnload)
	},

	// beforeRouteLeave (to, from, next) {
	// 	if (this.isDirty) {
	// 		next(false)
	// 		window.location = to.path // this is the trick
	// 	} else {
	// 		next()
	// 	}
	// },


	methods: {
		isMobileScreen,
		isDevEnvFn(){
			return isDevEnv
		},

		onRunCommandClicked(){
			let aiInput = JsonParseSecure(this.aiTestInput)
			console.log("GenogramToolMain.onRunCommandClicked: aiInput = ", aiInput)
			let genogramLayoutManager = new GenogramLayoutManager()
			let people = genogramLayoutManager.layoutFamilyTree(aiInput)

			this.$refs.genogramMain.setGenogramData(people)
		},

		async actionListener({action}, prams) {
			console.log("GenogramToolMain.actionListener: action = ", action)
			switch (action) {
				case "exportGenogram":
					await this.loadFullApp({progress: true})
					if(!this.isLoggedIn){
						await messageDialog({
							title: "Please first save genogram to export it",
							message: `Click "${this.saveButtonTextComputed}" on the right to save and export it`
						})
						console.log("GenogramToolMain.actionListener: not logged in")
						return false
					}

					this.isLoadingGlobal = true
					return true
				case "exportGenogramCompleted":
					this.isLoadingGlobal = false
					return true

			}


		},

		async onFeedbackClicked(){
			await this.loadFullApp({progress: true})
		},

		async onDetailsVisibilityChanged(isVisible) {
			await this.loadFullApp({progress: true})
		},

		async onTemplateAdded(isVisible) {
			await this.loadFullApp({progress: true})
		},

		async loadFullApp(options = {}) {
			if(!this.loadFullAppPromise){
				// eslint-disable-next-line no-async-promise-executor
				this.loadFullAppPromise = new Promise(async (resolve) => {
					let {progress} = options
					if(progress){
						this.isLoadingGlobal = true
					}
					let analyticManager = this.$analyticManager
					await import("@/entry/importFull.js")

					// we need to ensure all the dialogs are loaded at this point
					// to prevent cases when a new version deploys while user works
					// on a genogram which will prevent them from saving the genogram if not preloaded
					// (chunks with the dialogs may be unavailable in this case)
					await Promise.all([
						CreateCoachAccountDialog(),
						CreateAccountGenogramDialog(),
						GenogramSurveyDialog(),
					])


					console.log("GenogramToolMain.loadFullApp: this.$analyticManager new = ", this.$analyticManager, ", analyticManager = ", analyticManager)
					if(typeof analyticManager.flushEventsTo === "function"){
						analyticManager.flushEventsTo(this.$analyticManager)
					}
					// await import("@/entry/elementui-imports")

					await this.onFullAppLoaded()
					this.isLoadingGlobal = false
					resolve()
				})
			}

			await this.loadFullAppPromise

		},

		async onFullAppLoaded(){
			// clientProfile will not have id since we don't load full DataManager initially for SEO performance.
			// so we set it here if needed
			console.log("GenogramToolMain.onFullAppLoaded before: clientProfile = ", this.clientProfile, ", this.clientProfile.id = ", this.clientProfile.id)
			if(!this.clientProfile.id){
				this.clientProfile.generateId()
				let genogramItem = this.getGenogramItem()
				genogramItem.clientId = this.clientProfile.id
				genogramItem.addSharedWithById([this.clientProfile.id])
			}
			console.log("GenogramToolMain.onFullAppLoaded after: clientProfile = ", this.clientProfile, ", this.clientProfile.id = ", this.clientProfile.id)

		},

		saveSettingsFromUrl(){
			let queryOptions = this.$route.query.opt || ""
			let querySettings = JsonParseSecure(fromBase64(queryOptions)) || {}
			console.log("GenogramToolMain.saveSettingsFromUrl: querySettings = ", querySettings, ", queryOptions = ", queryOptions)

			let settings = this.cookieSettings.get() || {}
			let extraOptions = {}
			if(this.$route.query.utm_ad && !settings.utm_ad){
				extraOptions.utm_ad = this.$route.query.utm_ad
			}

			settings = {
				...settings,
				...this.settingsParam,
				...querySettings,
				...extraOptions}
			this.cookieSettings.set(settings)
		},

		restoreSettings(){
			let savedSettings = this.cookieSettings.get() || {}
			this.settings = {...savedSettings, ...this.settings}

			console.log("GenogramToolMain.restoreSettings: settings = ", this.settings)
		},

		setupUtmParams(){
			if(isObject(this.utm_params)){

				let utmParams = {}
				Object.keys(this.utm_params).forEach(key => {
					utmParams[key] = this.utm_params[key]
					utmParams[`initial_${key}`] = this.utm_params[key]
				})

				this.$analyticManager.setUserPropsOnce(utmParams)
			}
		},

		setupCampaignData(){

			let planMonthly = this.noTrialPlanMonthly
			let planYearly = this.noTrialPlanYearly

			if(this.settings["m"]){
				this.settings[SettingNameEnum.PLAN_ID_YEARLY] = this.settings["y"]
			}
			if(this.settings["y"]){
				this.settings[SettingNameEnum.PLAN_ID_MONTHLY] = this.settings["m"]
			}
			if(this.settings["pm"]){
				this.settings[SettingNameEnum.PRICE_MONTHLY] = this.settings["pm"]
			}
			if(this.settings["py"]){
				this.settings[SettingNameEnum.PRICE_YEARLY] = this.settings["py"]
			}
			if(this.settings["se"]){
				this.settings[SettingNameEnum.SHOW_STUDENT_ENROLLMENT] = this.settings["se"]
			}

			//enabled it for tests on 10 Oct 2024
			//upd 19 Oct - payment performance dropped. reverting to standard settings
			// this.settings[SettingNameEnum.SHOW_STUDENT_ENROLLMENT] = true


			//force no trial plan for tests on 12 Oct 2024
			//testing if this will encourage more students to share enrollment with their teachers

			//19 Oct - performance dropped. Reenable free trial for the ad "genogram_7d_trial"
			if(!this.settings[SettingNameEnum.PLAN_ID_YEARLY]
				&& this.settings["utm_ad"] !== "genogram_7d_trial"){
				this.settings[SettingNameEnum.PLAN_ID_MONTHLY] = planMonthly
			}


			if(this.settings["no-trial"]){
				this.settings[SettingNameEnum.PLAN_ID_MONTHLY] = planMonthly
				this.settings[SettingNameEnum.PLAN_ID_YEARLY] = planYearly
			}
			if(this.settings["no-trial-monthly"]){
				this.settings[SettingNameEnum.PLAN_ID_MONTHLY] = planMonthly
			}
			if(this.settings["no-trial-yearly"]){
				this.settings[SettingNameEnum.PLAN_ID_YEARLY] = planYearly
			}
			if(this.settings["disable-monthly"]) {
				delete this.settings[SettingNameEnum.PLAN_ID_MONTHLY]
			}
			if(this.settings["disable-yearly"]) {
				delete this.settings[SettingNameEnum.PLAN_ID_YEARLY]
			}

			// if(isDevEnv){
			// 	this.settings[SettingNameEnum.PLAN_ID_MONTHLY] = mapPlanDev(this.settings[SettingNameEnum.PLAN_ID_MONTHLY])
			// 	this.settings[SettingNameEnum.PLAN_ID_YEARLY] = mapPlanDev(this.settings[SettingNameEnum.PLAN_ID_YEARLY])
			// }


			if(this.settings["tutorial-off"]){
				this.canShowTutorial = false
			}

			console.log("GenogramToolMain.setupCampaignData: settings = ", this.settings)
		},

		showVideoDialogClicked() {
			let _ = this.$analyticManager.trackEvent("Button clicked: show tutorial video")
			this.showVideoDialog()
		},

		async showVideoDialog() {
			if(!this.canShowTutorial){
				return
			}
			await this.loadFullApp({progress: true})
			let _ = this.$analyticManager.trackEvent("Tutorial video opened")
			await videoDialog({
				width: "560",
				showCancel: false,
				title: "How to create a genogram (in under 4 minutes)",
				subTitle: isMobileScreen() ? "Tip: switch to landscape mode or open on desktop for better experience.<br/>To add a symbol, just tap it, and then tap on the canvas.<br/><br/>" : "",
				// gDriveVideoUrl: "https://drive.google.com/file/d/1MqDD7vA6l--9XPwIY9NQX0177r5wYLUw/preview",
				youtubeUrl: "https://www.youtube.com/embed/jImpP6bY8Eg",
				params: {
					width: "500px",
					height: "315px"
				},
				description: "<h4>The video covers how to</h4>" +
					"00:09 - Add a person to your Genogram<br/>" +
					"00:29 - Add family relationships<br/>" +
					"00:45 - List of available emotional and family relationships<br/>" +
					"01:17 - Add twins/siblings<br/>" +
					"01:39 - Add emotional relationships<br/>" +
					"02:05 - Add multiple emotional relationships for the same people<br/>" +
					"02:21 - Add relationships with arrow (directional relationships)<br/>" +
					"02:45 - Remove a relationship connection<br/>" +
					"02:54 - Labels, age, notes and other properties of a person<br/>" +
					"03:04 - Add custom Health Conditions<br/>" +
					"04:07 - Legend - auto generated<br/>"
			})
		},

		beforeWindowUnload(e) {
			console.log("beforeWindowUnload: this.isDirty = ", this.isDirty, ", e = ", e)
			if (this.isDirty) {
				e.preventDefault()
				e.returnValue = ''
				this.$analyticManager.trackEvent("Leave without saving warning shown")
			}
		},
		async onSaveClicked() {
			await this.loadFullApp({progress: true})
			if(this.isTeacherEnrollment()){
				return this.goOptions({
					name: "GenogramForClassEnroll",
					query: {enrollmentId: this.$route.query.enrollmentId}
				})
			}
			let _ = this.$analyticManager.trackEvent("Genogram tools save clicked")
			// await this.showSurvey()F

			// if(isDevEnv){
			// 	await this.showInstructionsDialog()
			// }
			let genogramItem = this.getGenogramItem()
			try{
				this.$analyticManager.trackEvent("Saving genogram", {genogram: JSON.stringify(genogramItem)})
			} catch (error){
				let _ = logError(error)
			}

			let clientName = await getClientNameDialog({
				purposeQuestion: "What's your role? (please be as specific as possible)",
				itemNameProp: "Genogram",
				firstTouch: "genogram_tools",
				// onAccountCreated: () => this.onAccountCreated()
			})

			if (!clientName) {
				return
			}

			this.clientProfile.name = clientName
			this.clientProfile.toolsSettings.enableCoachingTool(GenogramToolId)


			if(this.studentClassPlanId){
				this.settings[SettingNameEnum.PLAN_ID_MONTHLY] = this.studentClassPlanId
			}

			if(this.teacherData){
				if(this.isStudentAccessFreeTrial){
					this.settings[SettingNameEnum.EXTRA_MESSAGE] = `Special Student Free Trial by ${this.teacherName}`
				}
				this.$analyticManager.trackEvent("Teacher referral", {teacherId: this.teacherId, teacehrName: this.teacherName})
			}

			let planIdMonthly = this.settings[SettingNameEnum.PLAN_ID_MONTHLY]
			let planIdYearly = this.settings[SettingNameEnum.PLAN_ID_YEARLY]


			console.log("planIdMonthly = ", planIdMonthly)

			let userProfile

			let isNewAccount = false

			if(this.currentUser && this.userProfile){
				userProfile = this.userProfile
			} else {

				userProfile = await createAccountGenogramDialog({
					planIdMonthly: planIdMonthly || undefined,
					planIdYearly: planIdYearly || undefined,
					productName: "EasyGenogram by Qwoach",
					skipCreditCard: this.studentSkipCreditCard,
					canShowStudentEnrollDialog: !this.hasTeacher,
					settings: this.settings,
					lockedAccountCreated: (userProfile) => this.onLockedAccountCreated(userProfile),
					userExtraProps: {
						firstTouch: "genogram_tools",
						account: "genogram",
						...this.studentExtraProps,
					}
				})
				isNewAccount = true
			}


			if (!userProfile) {
				return
			}

			// if(clientName){
			if (genogramItem) {
				if(genogramItem.clientId !== this.clientProfile.id){
					genogramItem.clientId = this.clientProfile.id
				}
				if(isNewAccount){
					await this.onAccountCreated()
				}
				await this.handleAsync(async () => {

					await this.dataManager.createClientProfile(this.clientProfile)
					await this.dataManager.setGenogramItem(genogramItem)
					let tagsContainer = await this.localDataManager.getTagsContainerItem()
					await this.dataManager.setTagsContainer(tagsContainer)
					// if(isNewAccount){
					// 	await this.showSurvey()
					// }
					this.isDirty = false


					// we can't use this.go() because GenogramToolMain.vue is part of the optimized genogram entry point that doesn't include routes related to ClientDetails.
					// await this.go("ClientDetailsMainGenogram", {clientProfileId: this.clientProfile.id})

					let host = window.location.origin
					let clientId = this.clientProfile.id

					let url = `${host}/recovery/clients/${clientId}/details/genogram?genogramInstructions=true`

					window.location = url


					// await this.showInstructionsDialog()

				})
			}
			// }

		},

		getPlanId() {
			return this.settings[SettingNameEnum.PLAN_ID_MONTHLY] || undefined
		},

		async showSurvey() {

			// await genogramSurveyDialog()
			// this.toast("Thanks a lot! Your answers will help us improve!")
		},



		async onLockedAccountCreated(userProfile) {
			this.$analyticManager.trackEvent("Genogram locked account created")
			await this.dataManager.apiPostCreateGenogramAndClientItem({
				userId: userProfile.id,
				genogramItem: this.getGenogramItem(),
				clientProfile: this.clientProfile
			})
			this.isDirty = false
			// this.$analyticManager.setUserPropsOnce({account: "genogram"})
		},

		getGenogramItem(){
			return this.$refs.genogramMain.genogramItem
		},

		onAccountCreated(userProfile) {
			this.$analyticManager.trackEvent("Genogram account created")
			// this.$analyticManager.setUserPropsOnce({account: "genogram"})
		},



		async goToDashboard() {
			let _ = this.$analyticManager.trackEvent("Genogram tools go to dashboard clicked")
			await this.go("CoachMain")
		},

		isTeacherEnrollment(){
			return !!this.$route.query.enrollmentId
		}
	},

	computed: {
		saveButtonTextComputed() {
			if(this.isTeacherEnrollment()){
				return isMobileScreen() ? "Enroll" : "Enroll My Class"
			}

			return  isMobileScreen() ? "Save" : "Save Genogram"
		},

		savePanelTopComputed() {
			return this.isMobileScreen() ? "50px" : "5px"
		},

		savePanelBottomComputed() {
			return this.isMobileScreen() ? "5px" : null
		},

		showTutorialTitleComputed() {
			return this.isMobileScreen() ? "Tutorial" : "Show Tutorial"
		},


		teacherMap(){
			return teacherMapObj
		},


		teacherData() {
			return this.teacherMap[this.teacherId] || {}
		},
		teacherName() {
			return this.teacherData.name || ""
		},
		className() {
			return this.teacherData.class || "class"
		},
		programName() {
			return this.teacherData.programName || "genogram"
		},
		teacherUid() {
			return this.teacherData.userId
		},
		hasTeacher() {
			return this.teacherMap[this.teacherId]
		},

		studentSkipCreditCard(){
			return this.isStudentAccessFull
		},

		studentClassPlanId() {
			if(this.isStudentAccessFreeTrial){
				return "793798"
			}
			return null
		},

		isStudentAccessFreeTrial(){
			return this.teacherData.access === "freeTrial"
		},

		isStudentAccessFull(){
			return this.teacherData.access === "classPaid"
		},

		studentExtraProps() {
			let props = {}
			if(this.hasTeacher){
				props = {
					...props,
					isStudent: true,
					teacherUid: this.teacherUid,
					teacherIdPublic: this.teacherId,
					genogramAccess: this.teacherData.access,
				}
			}
			return props
		},

	}
}
</script>

<style lang="scss">

</style>
